import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const QuizGradingPage = () => {
  const { quizId } = useParams();
  const [subs, setSubs] = useState([]);
  const [scores, setScores] = useState({});

  useEffect(() => {
    axios.get(`/api/submissions/${quizId}/ungraded`)
      .then(res => setSubs(res.data.submissions))
      .catch(console.error);
  }, [quizId]);

  const handleScoreChange = (subId, val) => {
    setScores(prev => ({ ...prev, [subId]: val }));
  };

  const handleSubmit = async subId => {
    const finalScore = parseFloat(scores[subId]);
    try {
      await axios.put(`/api/submissions/${subId}/grade`, { finalScore });
      setSubs(prev => prev.filter(s => s.id !== subId));
    } catch (err) {
      alert(err.response?.data?.error || 'Grade submission failed');
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl mb-4">Grade Quiz {quizId}</h1>
      {subs.length === 0 && <p>No ungraded submissions.</p>}
      {subs.map(s => (
        <div key={s.id} className="mb-6 border p-4">
          <h2 className="font-semibold">Submission {s.id} by User {s.userId}</h2>
          {s.ungradedAnswers.map(a => (
            <div key={a.questionId} className="mb-2">
              <div>Q{a.questionId}: {a.answer}</div>
            </div>
          ))}
          <div className="flex items-center">
            <input
              type="number"
              placeholder="Score"
              value={scores[s.id] || ''}
              onChange={e => handleScoreChange(s.id, e.target.value)}
              className="border p-1 mr-2 w-20"
            />
            <button
              onClick={() => handleSubmit(s.id)}
              className="bg-green-500 text-white px-3 py-1 rounded"
            >
              Submit Grade
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuizGradingPage;
